module.exports = __webpack_public_path__ + "static/media/jacktop-banner-logo.20006938.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/jacktop-games/jacktop-banner-logo.png
// module id = 903
// module chunks = 7